module.exports = __webpack_public_path__ + "img/home_bg_05_1.9ea0ec3b.png";